<template>
  <div class="artwork-workbench">
    <!-- 氛围背景 - 清爽渐变 -->
    <div class="ambient-bg"></div>

    <div class="workbench-inner">
      <!-- 顶部状态栏 -->
      <div class="status-bar">
        <div class="status-left">
          <div class="logo-mark">
            <div class="logo-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M12 22V12M3 8l9 5 9-5" stroke="currentColor" stroke-width="1.5"/>
              </svg>
            </div>
            <span class="logo-text">消息工作台</span>
          </div>
        </div>
        <!--<div class="status-right">-->
        <!--  <div class="user-chip">-->
        <!--    <div class="user-avatar">-->
        <!--      <span>{{ currentUser.realName.charAt(0) }}</span>-->
        <!--    </div>-->
        <!--    <div class="user-info">-->
        <!--      <span class="user-name">{{ currentUser.realName. }}</span>-->
        <!--      <span class="user-role">运营中心</span>-->
        <!--    </div>-->
        <!--  </div>-->
        <!--</div>-->
      </div>

      <!-- 主视觉区 Hero -->
      <div class="hero-section">
        <div class="hero-content">
          <div class="greeting-badge">
            <span class="badge-dot"></span>
            {{ currentDate }}
          </div>
          <h1 class="hero-title">
            {{ currentUser.realName }}，你的消息中心
          </h1>
          <p class="hero-subtitle">管理所有重要通知，不错过任何关键信息</p>
        </div>
        <div class="hero-stats">
          <template v-for="(item, index) in metrics">
            <div class="hero-stat-item" :key="item.key" @click="setFilter(item.key,item.priority)">
              <span :class="getStatValueClass(item.key)">{{ item.value ? item.value : 0 }}</span>
              <span class="hero-stat-label">{{ item.label }}</span>
            </div>
            <div class="hero-stat-divider" :key="`divider-${item.key}`" v-if="index < metrics.length - 1"></div>
          </template>
        </div>
      </div>

      <!-- 核心指标卡片 -->
      <div class="metrics-grid">
        <div
            v-for="metric in metrics"
            :key="metric.key"
            class="metric-card"
            :class="{ 'is-active': activeMetric == metric.key }"
            @click="setFilter(metric.key,metric.priority)"
        >
          <div class="metric-icon" :class="metric.iconClass">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path :d="metric.iconPath" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="metric-info">
            <div class="metric-value">{{ metric.value }}</div>
            <div class="metric-label">{{ metric.label }}</div>
          </div>
        </div>
      </div>

      <div class="tableBox"  :style="{ position: 'relative' }">
        <el-form :inline="true" :model="dataForm" size="small">
          <el-form-item label="类型">
            <el-select class="item-choose" v-model="dataForm.paramMap.messageType" filterable clearable placeholder="类型">
              <el-option v-for="item in dictTypeMap.message_type" :key="item.id" :label="item.name" :value="item.code.toString()"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优先级">
            <el-select class="item-choose" v-model="dataForm.paramMap.priority" filterable clearable placeholder="优先级">
              <el-option label="普通" :value="'0'"></el-option>
              <el-option label="重要" :value="'1'"></el-option>
              <el-option label="紧急" :value="'2'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="终端类型">
            <el-select class="item-choose" v-model="dataForm.paramMap.terminalType" filterable clearable placeholder="终端类型">
              <el-option label="全平台" :value="'0'"></el-option>
              <el-option label="司机端" :value="'1'"></el-option>
              <el-option label="调度端/PC端" :value="'2'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="消息方式">
            <el-select class="item-choose" v-model="dataForm.paramMap.confirm" filterable clearable placeholder="是否需确认">
              <el-option label="自动确认" :value="'0'"></el-option>
              <el-option label="手动确认" :value="'1'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="allRefresh()" type="primary">查询</el-button>
            <el-button @click="() => this.dataForm = this.$options.data().dataForm" type="info">重置</el-button>
            <el-button @click="allHaveBeenDealtWith()" type="danger">全部已处理</el-button>
            <el-button size="small" @click="templateConfigurationMode(0)" type="warning">模板配置模式</el-button>
          </el-form-item>
        </el-form>
        <el-row v-if="config.isConfigMode" style="justify-self: center;padding: 10px 10px">
          <el-button size="mini" @click="config.isConfigMode = false" type="danger">取消配置模式</el-button>
          <el-button v-no-more-click size="mini" @click="templateConfigurationMode(1)" type="success">保存模板</el-button>
          <el-button v-no-more-click size="mini" @click="templateConfigurationMode(2)" type="warning">修改模板</el-button>
          <el-button v-no-more-click size="mini" @click="$refs.configTableRef.init(config.configTableId)" type="warning">所有模板</el-button>
          <el-popover placement="right" width="520" trigger="click">
            <div style="justify-self: center;">
              <el-button v-no-more-click @click="checkAllNodes(true)" size="mini">全选</el-button>
              <el-button v-no-more-click @click="checkAllNodes(false)" size="mini">全不选</el-button>
              <el-tooltip class="item" effect="dark" content="可拖拽必须先取消固定才允许拖拽排列,如果有固定固定按钮会显示为绿色" placement="top-start">
                <i class="el-icon-view el-icon--right" />
              </el-tooltip>
            </div>
            <br/>
            <el-tree :data="config.configDefaultColumn"
                     style="max-height: 200px;overflow-y: auto;"
                     default-expand-all
                     show-checkbox
                     draggable
                     node-key="prop"
                     ref="configTableListTree"
                     @check-change="handleCheckChange"
                     @node-drop="handleDrop"
                     :allow-drag="allowDrag"
                     :allow-drop="allowDrop">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <el-row :gutter="20">
                       <el-col :span="16">
                         <div class="grid-content bg-purple">
                           <el-input size="mini" placeholder="列头名" v-model="data.label"></el-input>
                         </div>
                       </el-col>
                       <el-col :span="8">
                         <div class="grid-content bg-purple">
                           <el-link :type="data.fixed && data.fixed === 'left' ? 'success' : 'info'" @click="data.fixed = 'left'" :underline="false" >固定左侧</el-link>
                           <el-link :type="data.fixed && data.fixed === 'right' ? 'success' : 'info'" @click="data.fixed = 'right'" :underline="false" >固定右侧</el-link>
                           <el-link :disabled="!data.fixed" :underline="false" @click="data.fixed = undefined" >取消固定</el-link>
                         </div>
                       </el-col>
                    </el-row>
                  </span>
            </el-tree>
            <el-button style="margin-left: 10px;" size="mini" slot="reference" icon="el-icon-s-tools" circle />
          </el-popover>
          <br/>
          <br/>
          <el-row type="flex" class="row-bg" justify="space-around">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-input v-model="config.configModeForm.name" size="mini" placeholder="模板名称" clearable />
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple-light">
                <el-input v-model="config.configModeForm.remark" size="mini" placeholder="备注" clearable />
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-switch
                    v-model="config.configModeForm.defaultOrNot"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="'1'"
                    :inactive-value="'0'">
                </el-switch>
              </div>
            </el-col>
          </el-row>
        </el-row>
        <el-table :data="tableList"
                ref="tableRef"
                height="72vh"
                size="small"
                v-loading="tableLoading"
                border
                style="width: 100%;"
                :cell-class-name="getCellClassName">
        <el-table-column
            v-for="(item, index) in config.configDefaultColumn"
            :key="index"
            align="left"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :show-overflow-tooltip="true"
            v-if="item.check"
            :class="item.styleClass"
            :class-name="item.styleClass">
          <template slot-scope="scope">
            <!-- 状态 -->
            <template v-if="item.prop == 'isRead'">
              <el-tag v-if="scope.row.isRead == 0" size="small" type="danger">未读</el-tag>
              <el-tag v-else size="small">已读</el-tag>
            </template>
            <!-- 优先级 -->
            <template v-else-if="item.prop == 'priority'">
              <el-tag v-if="scope.row.priority == 0">普通</el-tag>
              <el-tag v-if="scope.row.priority == 1" type="warning">重要</el-tag>
              <el-tag v-if="scope.row.priority == 2" type="danger">紧急</el-tag>
            </template>
            <!-- 消息类型 -->
            <template v-else-if="item.prop == 'messageType'">
              <el-tag> {{ getMessageTypeName(scope.row.messageType) }} </el-tag>
            </template>
            <!-- 终端类型 -->
            <template v-else-if="item.prop == 'terminalType'">
              <el-tag v-if="scope.row.terminalType == 0">全平台</el-tag>
              <el-tag v-if="scope.row.terminalType == 1">司机端</el-tag>
              <el-tag v-if="scope.row.terminalType == 2">调度端/PC端</el-tag>
            </template>
            <!-- 可见范围 -->
            <template v-else-if="item.prop == 'globalType'">
              <el-tag v-if="scope.row.globalType == 0">全员可见</el-tag>
              <el-tag v-if="scope.row.globalType == 1">指定人员</el-tag>
            </template>
            <!-- 消息方式 -->
            <template v-else-if="item.prop == 'confirm'">
              <el-tag v-if="scope.row.confirm == 0">自动确认</el-tag>
              <el-tag v-if="scope.row.confirm == 1">手动确认</el-tag>
            </template>
            <!-- 是否已处理 -->
            <template v-else-if="item.prop == 'isConfirm'">
              <el-tag v-if="!scope.row.handlerName" size="small" type="danger">未处理</el-tag>
              <el-tag v-else size="small">已处理</el-tag>
            </template>
            <template v-else>
              {{ getFormatter(item.formatter)(scope.row, item, _.get(scope.row, item.prop)) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button @click="viewDetail(scope.row)" type="text" size="mini">查看</el-button>
            <el-button @click="confirmMessage(scope.row)" v-if="isUnread(scope.row) && scope.row.confirm == 1" type="text" size="mini">已处理</el-button>
          </template>
        </el-table-column>
      </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="dataForm.page"
                     :page-sizes="[20, 50, 100]" :page-size="dataForm.size" :total="dataForm.total"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
      </div>


      <!--&lt;!&ndash; 过滤栏 &ndash;&gt;-->
      <!--<div class="filter-bar">-->
      <!--  <div class="filter-group">-->
      <!--    <button-->
      <!--        class="filter-pill"-->
      <!--        :class="{ 'is-selected': activeType == null && !activeMetric }"-->
      <!--        @click="resetFilters"-->
      <!--    >-->
      <!--      全部-->
      <!--      &lt;!&ndash;<span class="pill-count">{{ totalCount }}</span>&ndash;&gt;-->
      <!--    </button>-->
      <!--    <button-->
      <!--        v-for="type in dictTypeMap.message_type"-->
      <!--        :key="type.id"-->
      <!--        class="filter-pill"-->
      <!--        :class="{ 'is-selected': activeType == type.code }"-->
      <!--        @click="activeType = type.code; clearMetricFilter()"-->
      <!--    >-->
      <!--      {{ type.name }}-->
      <!--      &lt;!&ndash;<span class="pill-count">{{ typeCountMap[type.value] || 0 }}</span>&ndash;&gt;-->
      <!--    </button>-->
      <!--  </div>-->
      <!--  <div class="action-group">-->
      <!--    &lt;!&ndash;<button class="action-btn primary">&ndash;&gt;-->
      <!--    &lt;!&ndash;  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">&ndash;&gt;-->
      <!--    &lt;!&ndash;    <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>&ndash;&gt;-->
      <!--    &lt;!&ndash;  </svg>&ndash;&gt;-->
      <!--    &lt;!&ndash;  全部处理&ndash;&gt;-->
      <!--    &lt;!&ndash;  &lt;!&ndash;<span class="btn-badge" v-if="pendingConfirmCount > 0">{{ pendingConfirmCount }}</span>&ndash;&gt;&ndash;&gt;-->
      <!--    &lt;!&ndash;</button>&ndash;&gt;-->
      <!--    <button class="action-btn secondary" @click="refreshData">-->
      <!--      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">-->
      <!--        <path d="M23 4V10H17M1 20V14H7M3.51 9C5.03 5.47 8.68 3 13 3C18.08 3 22.11 6.89 22.95 11.84M20.49 15C18.97 18.53 15.32 21 11 21C5.92 21 1.89 17.11 1.05 12.16" stroke="currentColor" stroke-width="1.5"/>-->
      <!--      </svg>-->
      <!--      刷新-->
      <!--    </button>-->
      <!--  </div>-->
      <!--</div>-->

      <!--&lt;!&ndash; 消息列表 &ndash;&gt;-->
      <!--<div class="message-list">-->
      <!--  <div class="list-header">-->
      <!--    <h3>消息列表</h3>-->
      <!--    <span class="list-count" v-if="activeMetric || activeType !== null">-->
      <!--      共 {{ dataForm.total }} 条结果-->
      <!--    </span>-->
      <!--  </div>-->
      <!--  <div class="message-items" v-loading="tableLoading">-->
      <!--    <div v-for="msg in tableList" :key="msg.id" class="message-item" :class="getItemClass(msg)" @click="viewDetail(msg)">-->
      <!--      <div class="item-left">-->
      <!--        <div class="item-icon" :style="{ backgroundColor: getTypeColor(msg.messageType), opacity: isRead(msg) ? 0.5 : 1 }">-->
      <!--          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">-->
      <!--            <path :d="getTypeIconPath(msg.messageType)" stroke="white" stroke-width="1.5" fill="none"/>-->
      <!--          </svg>-->
      <!--        </div>-->
      <!--        <div class="item-content">-->
      <!--          <div class="item-title">-->
      <!--            <span :class="{ 'read-title': isRead(msg) }">{{ msg.title }}</span>-->
      <!--            <span v-if="msg.priority == 0" class="badge-read">普通</span>-->
      <!--            <span v-if="msg.priority == 1" class="badge-pending">重要</span>-->
      <!--            <span v-if="msg.priority == 2" class="badge-emergency">紧急</span>-->
      <!--            <span v-if="isUnread(msg)" class="badge-pending">{{ msg.confirm == 0 ? '待查看' : '待处理' }}</span>-->
      <!--            <span v-if="isRead(msg)" class="badge-read">已处理</span>-->
      <!--          </div>-->
      <!--          <div class="item-phrase" v-if="msg.phrase">-->
      <!--            <span class="phrase-label">短语</span>-->
      <!--            <span :class="{ 'read-text': isRead(msg) }">{{ msg.phrase }}</span>-->
      <!--          </div>-->
      <!--          <div class="item-meta">-->
      <!--            <span class="meta-type" :class="{ 'read-text': isRead(msg) }">{{ getMessageTypeName(msg.messageType) }}</span>-->
      <!--            <span class="meta-time" :class="{ 'read-text': isRead(msg) }">{{ msg.sendTime ? msg.sendTime : msg.createTime }}</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="item-right">-->
      <!--        <button class="item-btn" :class="{ 'read-btn': isRead(msg) }" @click.stop="viewDetail(msg)">查看</button>-->
      <!--        <button v-if="isUnread(msg) && msg.confirm == 1" class="item-btn confirm" @click.stop="confirmMessage(msg)">已处理</button>-->
      <!--      </div>-->
      <!--    </div>-->
      <!--    <div v-if="!tableLoading && tableList.length == 0" class="empty-state">-->
      <!--      <div class="empty-icon">-->
      <!--        <svg width="64" height="64" viewBox="0 0 24 24" fill="none">-->
      <!--          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" stroke="#CBD5E1" stroke-width="1.5"/>-->
      <!--        </svg>-->
      <!--      </div>-->
      <!--      <p>暂无消息</p>-->
      <!--    </div>-->

      <!--    <div class="pagination" v-if="dataForm.total > dataForm.size">-->
      <!--      <button class="page-btn" :disabled="dataForm.page == 1" @click="dataForm.page&#45;&#45;;getDataListV()">-->
      <!--        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><polyline points="15 18 9 12 15 6" stroke="currentColor" stroke-width="2"/></svg>-->
      <!--      </button>-->
      <!--      <span class="page-info">{{ dataForm.page }} / {{ Math.ceil(dataForm.total / dataForm.size) }}</span>-->
      <!--      <button class="page-btn" :disabled="dataForm.page >= Math.ceil(dataForm.total / dataForm.size)" @click="dataForm.page++;getDataListV()">-->
      <!--        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><polyline points="9 18 15 12 9 6" stroke="currentColor" stroke-width="2"/></svg>-->
      <!--      </button>-->
      <!--    </div>-->
      <!--  </div>-->
      <!--</div>-->
    </div>

    <!-- 模板配置弹窗 -->
    <configTable ref="configTableRef" />

    <!-- 详情弹窗 -->
    <div class="modal-mask" :class="{ 'is-visible': detailVisible }" @click.self="detailVisible = false">
      <div class="modal-container">
        <div class="modal-header">
          <div class="modal-tag" :style="{ backgroundColor: currentMessage ? getTypeColor(currentMessage.messageType) : '#CBD5E1' }">
            {{ currentMessage ? getMessageTypeName(currentMessage.messageType) : '' }}
          </div>
          <button class="modal-close" @click="detailVisible = false">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="1.5"/></svg>
          </button>
        </div>
        <div class="modal-body" v-if="currentMessage">
          <h3 class="modal-title" :class="{ 'read-title': isRead(currentMessage) }">{{ currentMessage.title }}</h3>
          <div class="modal-time">{{ currentMessage.sendTime ? currentMessage.sendTime : currentMessage.createTime }}</div>
          <div class="modal-time">{{ currentMessage.phrase }}</div>
          <div class="modal-divider"></div>
          <div class="modal-content" v-html="currentMessage.content || '暂无详细内容'"></div>
        </div>
        <div class="modal-footer" v-if="currentMessage && isUnread(currentMessage)">
          <button v-if="currentMessage.confirm == 1" class="modal-btn primary" @click="confirmMessage(currentMessage); detailVisible = false">确认处理</button>
          <!--<button v-if="currentMessage.target_type == 'ORDER'" class="modal-btn secondary" @click="goToOrder(currentMessage.target_id)">查看订单</button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as myPageColumConfig from "@/utils/pageColumConfig";
import * as myJsonClon from "@/utils/myJsonClone";
import configTable from "@/components/table/index.vue";

export default {
  name: 'home',
  components: {configTable},
  data() {
    return {
      // -----------------动态表格模式start-----------------
      config: myPageColumConfig.messageHomeLog,
      // -----------------动态表格模式end-----------------


      // 当前时间
      currentDate: '',

      // 消息数量
      classMap: {
        homeUrgent: 'hero-stat-value homeUrgent',
        homePending: 'hero-stat-value homePending',
        homeTotal: 'hero-stat-value homeTotal',
      },
      metrics: [
        { key: 'homeUrgent', label: '紧急待处理/查看',priority: '2', value: 0, iconClass: 'icon-urgent', iconPath: 'M12 8v4M12 16h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z' },
        { key: 'homePending', label: '待处理/查看',priority: '0,1', value: 0, iconClass: 'icon-pending', iconPath: 'M18 8A6 6 0 0 1 6 8c0-7 6-7 6-7s6 0 6 7zM4 18c2.5 2 5 2 8 2s5.5 0 8-2M12 22v-4' },
        { key: 'homeTotal', label: '总待处理/查看',priority: '0,1,2', value: 0, iconClass: 'icon-total', iconPath: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' }
      ],
      activeMetric: null,

      // 过滤器
      activeType: null,

      // 查询条件
      tableLoading: false,
      tableList: [],
      dataForm: {
        page: 1,
        size: 20,
        total: 0,
        paramMap: {}
      },
      iconPaths: {
        // 0: 订单消息 - 订单/购物袋图标
        0: 'M20 7L9 18L4 13',  // 对勾/完成标记，代表订单完成
        // 1: 系统公告 - 喇叭/公告图标
        1: 'M18 9V7c0-2.2-1.8-4-4-4H7C4.8 3 3 4.8 3 7v5c0 2.2 1.8 4 4 4h3l3 5v-5h1c2.2 0 4-1.8 4-4v-1',  // 喇叭图标
        // 2: 告警消息 - 警告/感叹号图标
        2: 'M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z',  // 警告/感叹号
        // 3: 活动消息 - 礼物/活动图标
        3: 'M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z',  // 暂时复用，下面有更合适的
        // 4: 系统消息 - 设置/齿轮图标
        4: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z',
        // 99: 未知消息 - 问号/未知图标
        99: 'M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z'  // 默认警告图标
      },


      messageTypeMap: new Map(),


      allMessages: [],
      typeCountMap: {},
      detailVisible: false,
      currentMessage: null
    }
  },
  computed: {
    // 当前用户信息
    currentUser: {
      get () { return this.$store.state.user.currentUser }
    },

    // 数据字典
    dictTypeMap: {
      get() {
        return this.$store.state.common.dictTypeMap
      }
    },
  },
  watch: {
    'dictTypeMap.message_type': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.messageTypeMap = new Map(newVal.map(item => [item.code, item.name]));
          // 如果需要在数据加载后刷新列表，可以调用
          // this.getDataListV();
        }
      },
      immediate: true, // 立即执行一次
      deep: true
    }
  },
  created() {
    this.initConfigTable()
  },
  activated() {
    this.initDate()
    this.getDataListV()
    this.getCount()
  },
  methods: {
    // -----------------动态表格模式start-----------------
    initConfigTable() {
      this.$http({
        url: this.$http.adornUrl('/tabulation/default/' + this.config.configTableId),
        method: 'get',
        params: this.$http.adornParams()
      }).then(async ({ data }) => {
        if (data) {
          this.config.configModeForm.name = data.name
          this.config.configModeForm.remark = data.remark
          this.config.configModeForm.defaultOrNot = data.defaultOrNot
          this.config.configId = data.id
          if (data.tmsTabulationConfigValueList && data.tmsTabulationConfigValueList.length > 0) {
            this.assignPropertiesLarge(this.config.configDefaultColumn, data.tmsTabulationConfigValueList,'prop',['label','fixed','width'])
            this.config.configDefaultColumn = this.reorderArray(this.config.configDefaultColumn, data.tmsTabulationConfigValueList, 'prop');
          }
        }
        this.config.configDefaultColumn.forEach(x => {
          this.config.configDefaultPropColumn.push({prop: x.prop})
          this.config.configDefaultPropColumnMap.set(x.prop,x)
        })
      })

    },
    assignPropertiesLarge (arr1, arr2, compareProp, assignProps) {
      const map = new Map();
      arr2.forEach(item => {
        map.set(item[compareProp], item);
      });
      arr1.forEach(item => {
        const match = map.get(item[compareProp]);
        if (match) {
          assignProps.forEach(prop => {
            item[prop] = match[prop];
          });
          item.check = true
        } else {
          item.check = false
        }
      });
      return arr1;
    },
    reorderArray(arr1, arr2, key) {
      if (arr2.length === 0) {
        return arr1;
      }

      // 存储第二个数组中元素的特定属性值
      const targetValues = arr2.map(item => item[key]);
      // 存储匹配的元素
      const matched = [];
      // 存储未匹配的元素
      const unmatched = [];

      // 遍历第一个数组，将匹配的元素和未匹配的元素分别存储
      for (const item of arr1) {
        if (targetValues.includes(item[key])) {
          matched.push(item);
        } else {
          unmatched.push(item);
        }
      }

      // 对匹配的元素进行排序，使其顺序与第二个数组一致
      const sortedMatched = targetValues.map(value => {
        return matched.find(item => item[key] == value);
      }).filter(item => item!== undefined);
      // 合并匹配的元素和未匹配的元素
      return [...sortedMatched, ...unmatched];
    },
    templateConfigurationMode(type) {
      // 开启配置模式
      if (type === 0) {
        this.config.isConfigMode = true
        this.$nextTick(() => {
          const tree = this.$refs.configTableListTree;
          this.config.configDefaultColumn.forEach((node) => {
            if (node.check) {
              tree.setChecked(node.prop, true);
            }
          });
        })
      }
      // 保存/修改配置模式
      else if (type === 1 || type === 2) {
        // 检测
        if (!this.config.configModeForm.name) {
          this.$message.error('请输入配置模板名称!');
          return
        }
        if (type === 2) {

          if (!this.config.configId) {
            this.$message.error('未检测出有配置相关模板并启用,请新增!');
            return
          }
        }
        this.$nextTick(() => {
          let submitTable = myJsonClon.getClone(this.config.configModeForm)
          submitTable.tableId = this.config.configTableId
          submitTable.id = type === 2 ? this.config.configId : undefined
          const tableRef = this.$refs.tableRef;
          let tmsTabulationConfigValueList = []
          tableRef.columns.forEach((x,index) => {
            tmsTabulationConfigValueList.push({label: x.label,prop: x.property,fixed: x.fixed,width: x.width,sort: index})
          })
          submitTable.tmsTabulationConfigValueList = tmsTabulationConfigValueList;
          this.$http({
            url: this.$http.adornUrl(type === 1 ? '/tabulation/add' : '/tabulation/update'),
            method: type === 1 ? 'post' : 'put',
            data: submitTable
          }).then(async ({ data }) => {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
            })
            window.location.reload()
          })

        })
      }
    },
    getFormatter(formatterName) {
      if (formatterName) {
        // 首先尝试从组件的 methods 中获取方法
        let method = this[formatterName];
        if (typeof method === 'function') {
          return method;
        }
        // 若组件的 methods 中没有，再尝试从 Vue.prototype 中获取方法
        method = Vue.prototype[formatterName];
        if (typeof method === 'function') {
          return method;
        }
      }
      // 若都没找到，返回一个直接返回原始值的函数
      return (row, column, cellValue) => cellValue;
    },
    checkAllNodes (isChecked) {
      this.$nextTick(() => {
        if (isChecked) {
          this.$refs.configTableListTree.setCheckedNodes(this.config.configDefaultPropColumn)
        } else {
          this.$refs.configTableListTree.setCheckedKeys([])
          this.$forceUpdate()
        }
      })
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      const tree = this.$refs.configTableListTree;
      tree.setChecked(draggingNode.data.prop, draggingNode.data.check);
    },
    handleCheckChange(data, checked, indeterminate) {
      const targetElement = this.config.configDefaultColumn.find(item => item.prop === data.prop);
      targetElement.check = checked
    },
    allowDrag(draggingNode) {
      return draggingNode.data.fixed ? false : true
    },
    allowDrop(draggingNode, dropNode, type) {
      return type === 'inner' ? false : true
    },
    getCellClassName({ row, column, rowIndex, columnIndex }) {
      let newVar = this.config.configDefaultPropColumnMap.get(column.property);
      if (newVar && newVar.styleClass) {
        return newVar.styleClass;
      }
      return '';
    },
    // -----------------动态表格模式end-----------------


    // 当前时间
    initDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      const weekday = weekdays[now.getDay()]
      // let timStr;
      // const hour = now.getHours()
      // if (hour < 12) {
      //   timStr = '早上好'
      // } else if (hour < 18) {
      //   timStr = '下午好'
      // } else {
      //   timStr = '晚上好'
      // }
      this.currentDate = `${year}.${month}.${day} ${weekday}`
    },

    // 获取数量
    getCount() {
      this.$http({
        url: this.$http.adornUrl(`/message_center/me/home_count`),
        method: 'POST',
        data: {
          paramMap: {
            terminalType: '0,2'
          }
        }
      }).then(({data}) => {
        for (let metric of this.metrics) {
          metric.value = data[metric.key]
        }
      })
    },
    getStatValueClass(key) {
      return this.classMap[key] || 'hero-stat-value'
    },

    // 点击卡片
    setFilter(key,priority) {
      this.activeMetric = this.activeMetric == key ? null : key
      this.activeType = null

      // 查询
      this.dataForm = this.$options.data().dataForm
      if (this.activeMetric) {
        this.dataForm.paramMap.priorityAndConfirmAndRead = priority
      }
      this.getDataListV();
    },

    // 过滤器
    resetFilters() {
      this.activeMetric = null
      this.activeType = null
      this.dataForm = this.$options.data().dataForm
      this.getDataListV()
    },
    clearMetricFilter() {
      this.activeMetric = null
      this.dataForm = this.$options.data().dataForm
      this.dataForm.paramMap.messageType = this.activeType
      this.getDataListV()
    },

    // 获取消息列表
    getDataListV() {
      let THIS = this
      this.tableLoading = true
      this.$http({
        url: this.$http.adornUrl('/message_center/me/page'),
        method: 'post',
        data: this.dataForm
      }).then((data) => {
        THIS.tableList = data.data.records
        THIS.dataForm.total = data.data.total
      }).finally(e => {
        this.tableLoading = false
      })
    },
    refreshData() {
      this.dataForm.page = 1
      this.getCount()
      this.getDataListV()
    },

    // 判断消息状态
    getItemClass(row) {
      if (this.isUnread(row)) return 'item-unread'
      if (this.isRead(row)) return 'item-read'
      return ''
    },
    isUnread(row) {
      return row.isRead == null || row.isRead == 0 || row.confirmTime == null;
    },
    isRead(row) {
      return row.isRead != null && row.isRead != 0 && row.confirmTime != null;
    },

    // 表格数据
    getTypeColor(type) {
      const map = { 0: '#10B981', 1: '#3B82F6', 2: '#F59E0B', 3: '#8B5CF6', 4: '#6B7280' }
      return map[type] || '#6B7280'
    },
    getTypeIconPath(type) {
      return this.iconPaths[type] || this.iconPaths[4]
    },
    getMessageTypeName(type) {
      return this.messageTypeMap.get(type) || '消息'
    },

    // 详情
    viewDetail(msg) {
      let THIS = this
      this.currentMessage = msg
      this.$http({
        url: this.$http.adornUrl('/message_center/me/read/' + msg.id + '/0'),
        method: 'GET',
        params: this.$http.adornParams()
      }).then((data) => {
        THIS.detailVisible = true
        setTimeout(() => {
          this.getDataListV()
          this.getCount()
        },500)
      }).finally(e => {})
    },
    async confirmMessage(row) {
      this.$confirm(`确定对[${row.title}]进行已处理]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/message_center/me/read/' + row.id + '/1'),
          method: 'GET',
          params: this.$http.adornParams()
        }).then(({data}) => {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getDataListV()
              this.getCount()
            }
          })
        })
      }).catch(() => {})
    },




    // 表格点击
    rowClick(row) {
      this.viewDetail(row)
    },
    // 每页数
    sizeChangeHandle(val) {
      this.dataForm.size = val
      this.dataForm.page = 1
      this.getDataListV()
    },
    // 当前页
    currentChangeHandle(val) {
      this.dataForm.page = val
      this.getDataListV()
    },
    // 全部已处理
    allHaveBeenDealtWith() {
      let THAT = this;
      this.$confirm(`确定对所有消息进行已处理操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        THAT.tableLoading = true
        this.$http({
          url: this.$http.adornUrl('/message_center/allHaveBeenDealtWith'),
          method: 'GET',
          params: this.$http.adornParams()
        }).then(({data}) => {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.allRefresh()
            }
          })
        })
      }).catch(() => {})
    },
    // 全量刷新
    allRefresh() {
      this.getDataListV()
      this.getCount()
    }
  }
}
</script>

<style scoped lang="scss">
.artwork-workbench {
  min-height: 100vh;
  background: #F5F7FB;

  .ambient-bg {
    position: fixed;
    top: -20%;
    right: -10%;
    width: 60%;
    height: 60%;
    background: radial-gradient(ellipse, rgba(16,185,129,0.04) 0%, transparent 70%);
    pointer-events: none;
    z-index: 0;
  }

  .workbench-inner {
    margin: 0 auto;
    padding: 24px 32px 48px;
    position: relative;
    z-index: 2;
  }

  .status-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;

    .logo-mark {
      display: flex;
      align-items: center;
      gap: 10px;

      .logo-icon {
        width: 36px;
        height: 36px;
        background: linear-gradient(135deg, #10B981, #059669);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg { stroke: white; stroke-width: 1.5; }
      }

      .logo-text {
        font-size: 18px;
        font-weight: 600;
        color: #1F2937;
      }
    }

    .user-chip {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 6px 16px 6px 8px;
      background: white;
      border-radius: 40px;
      box-shadow: 0 1px 3px rgba(0,0,0,0.05);

      .user-avatar {
        width: 36px;
        height: 36px;
        background: linear-gradient(135deg, #10B981, #059669);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        span { color: white; font-weight: 500; font-size: 14px; }
      }

      .user-name { font-size: 14px; font-weight: 500; color: #1F2937; }
      .user-role { font-size: 11px; color: #9CA3AF; }
    }
  }

  .hero-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    margin-bottom: 48px;

    .greeting-badge {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #ECFDF5;
      padding: 4px 12px;
      border-radius: 30px;
      font-size: 13px;
      color: #059669;
      margin-bottom: 16px;

      .badge-dot {
        width: 6px;
        height: 6px;
        background: #10B981;
        border-radius: 50%;
      }
    }

    .hero-title {
      font-size: 32px;
      font-weight: 600;
      margin: 0 0 8px;
      color: #1F2937;
    }

    .hero-subtitle {
      font-size: 15px;
      color: #6B7280;
      margin: 0;
    }

    .hero-stats {
      display: flex;
      align-items: center;
      gap: 24px;
      background: white;
      padding: 12px 24px;
      border-radius: 48px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.04);

      .hero-stat-item {
        text-align: center;
        cursor: pointer;
        transition: transform 0.2s;

        &:hover { transform: translateY(-2px); }

        .hero-stat-value {
          font-size: 28px;
          font-weight: 700;
          display: block;
          line-height: 1.2;

          &.homeUrgent { color: #EF4444; }
          &.homePending { color: #F59E0B; }
          &.homeTotal { color: #10B981; }
        }

        .hero-stat-label {
          font-size: 12px;
          color: #9CA3AF;
          margin-top: 4px;
        }
      }

      .hero-stat-divider {
        width: 1px;
        height: 30px;
        background: #E5E7EB;
      }
    }

    .hero-title-light {
      font-weight: 400;
      color: #64748B;
    }
  }

  .metrics-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 32px;

    .metric-card {
      background: white;
      border-radius: 20px;
      padding: 16px 20px;
      display: flex;
      align-items: center;
      gap: 16px;
      cursor: pointer;
      transition: all 0.2s;
      box-shadow: 0 1px 3px rgba(0,0,0,0.04);
      border: 1px solid transparent;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0,0,0,0.08);
      }

      // 激活状态 - 改为清爽的浅色方案
      &.is-active {
        background: #ECFDF5;  // 浅绿色背景
        border-color: #10B981;  // 绿色边框

        .metric-label {
          color: #065F46;  // 深绿色文字
        }
        .metric-value {
          color: #10B981;  // 绿色数值
        }
        .metric-icon svg {
          stroke: #10B981;  // 绿色图标
        }
      }

      .metric-icon {
        width: 48px;
        height: 48px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;

        // 各图标背景色保持不变
        &.icon-urgent { background: #FEF2F2; svg { stroke: #EF4444; } }
        &.icon-pending { background: #FFFBEB; svg { stroke: #F59E0B; } }
        &.icon-today { background: #ECFDF5; svg { stroke: #10B981; } }
        &.icon-total { background: #EFF6FF; svg { stroke: #3B82F6; } }
      }

      .metric-value {
        font-size: 28px;
        font-weight: 700;
        color: #1F2937;
        line-height: 1.2;
      }

      .metric-label {
        font-size: 13px;
        color: #6B7280;
        margin-top: 4px;
      }
    }
  }

  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 28px;

    .filter-group {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;

      .filter-pill {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 18px;
        border-radius: 40px;
        background: white;
        border: 1px solid #E5E7EB;
        font-size: 13px;
        font-weight: 500;
        color: #4B5563;
        cursor: pointer;
        transition: all 0.2s;

        &:hover { border-color: #10B981; color: #10B981; }

        &.is-selected {
          background: #1F2937;
          border-color: #1F2937;
          color: white;

          .pill-count { background: rgba(255,255,255,0.2); color: white; }
        }

        .pill-count {
          background: #F3F4F6;
          padding: 0 6px;
          border-radius: 20px;
          font-size: 11px;
          color: #6B7280;
        }
      }
    }

    .action-group {
      display: flex;
      gap: 12px;

      .action-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 18px;
        border-radius: 40px;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s;
        border: 1px solid transparent;

        &.primary {
          background: #1F2937;
          color: white;

          &:hover:not(:disabled) { background: #374151; }
          &:disabled { opacity: 0.5; cursor: not-allowed; }

          .btn-badge {
            background: #EF4444;
            border-radius: 20px;
            padding: 0 6px;
            font-size: 11px;
          }
        }

        &.secondary {
          background: white;
          border-color: #E5E7EB;
          color: #4B5563;

          &:hover { background: #F9FAFB; border-color: #D1D5DB; }
        }
      }
    }
  }

  .message-list {
    background: white;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04);

    .list-header {
      padding: 20px 24px;
      border-bottom: 1px solid #F3F4F6;
      display: flex;
      justify-content: space-between;
      align-items: baseline;

      h3 {
        font-size: 16px;
        font-weight: 600;
        color: #1F2937;
        margin: 0;
      }

      .list-count {
        font-size: 13px;
        color: #9CA3AF;
      }
    }

    .message-items {
      .message-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 24px;
        border-bottom: 1px solid #F9FAFB;
        cursor: pointer;
        transition: background 0.2s;

        &:hover {
          background: #F9FAFB;
        }

        // 待处理消息 - 高亮背景
        &.item-unread {
          background: #F0FDF4;

          .item-title {
            .read-title { color: #065F46; font-weight: 600; }
          }
        }

        // 已处理消息 - 灰色调
        &.item-read {
          background: #FAFAFA;

          .item-icon {
            filter: grayscale(0.3);
          }
        }

        .item-left {
          display: flex;
          gap: 14px;
          flex: 1;

          .item-icon {
            width: 40px;
            height: 40px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            transition: opacity 0.2s;
          }

          .item-content {
            flex: 1;

            .item-title {
              font-size: 15px;
              font-weight: 500;
              color: #1F2937;
              margin-bottom: 6px;
              display: flex;
              align-items: center;
              gap: 8px;
              flex-wrap: wrap;

              .read-title {
                color: #9CA3AF !important;
                font-weight: 400;
              }

              .badge-emergency {
                background: #FEF2F2;
                color: #EF4444;
                font-size: 11px;
                padding: 2px 8px;
                border-radius: 20px;
                font-weight: 500;
              }

              .badge-pending {
                background: #FFFBEB;
                color: #F59E0B;
                font-size: 11px;
                padding: 2px 8px;
                border-radius: 20px;
                font-weight: 500;
              }

              .badge-read {
                background: #F3F4F6;
                color: #9CA3AF;
                font-size: 11px;
                padding: 2px 8px;
                border-radius: 20px;
                font-weight: 400;
              }
            }

            .item-phrase {
              font-size: 13px;
              color: #6B7280;
              margin-bottom: 6px;

              .phrase-label {
                background: #F3F4F6;
                padding: 2px 8px;
                border-radius: 12px;
                font-size: 11px;
                margin-right: 8px;
              }

              .read-text {
                color: #B9C2CC;
              }
            }

            .item-meta {
              display: flex;
              gap: 16px;
              font-size: 12px;

              .meta-type { color: #9CA3AF; }
              .meta-time { color: #9CA3AF; }

              .read-text {
                color: #C1C9D2;
              }
            }
          }
        }

        .item-right {
          display: flex;
          gap: 12px;

          .item-btn {
            background: none;
            border: none;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            color: #9CA3AF;
            transition: color 0.2s;

            &:hover { color: #10B981; }
            &.confirm { color: #F59E0B; &:hover { color: #D97706; } }
            &.read-btn {
              color: #D1D5DB;
              cursor: default;
              &:hover { color: #D1D5DB; }
            }
          }
        }
      }
    }

    .empty-state {
      text-align: center;
      padding: 60px 20px;

      .empty-icon svg { stroke: #D1D5DB; }
      p { color: #9CA3AF; font-size: 14px; margin-top: 16px; }
    }

    .pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;
      padding: 20px 24px;
      border-top: 1px solid #F3F4F6;

      .page-btn {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: white;
        border: 1px solid #E5E7EB;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        &:hover:not(:disabled) { background: #F9FAFB; border-color: #D1D5DB; }
        &:disabled { opacity: 0.4; cursor: not-allowed; }
      }

      .page-info {
        font-size: 13px;
        color: #6B7280;
      }
    }
  }

  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(31,41,55,0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s;

    &.is-visible {
      opacity: 1;
      visibility: visible;
    }

    .modal-container {
      background: white;
      width: 480px;
      max-width: 90vw;
      border-radius: 28px;
      overflow: hidden;
      transform: scale(0.96);
      transition: transform 0.2s;

      .modal-mask.is-visible & { transform: scale(1); }
    }

    .modal-header {
      padding: 20px 24px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .modal-tag {
        padding: 4px 12px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 500;
        color: white;
      }

      .modal-close {
        background: #F3F4F6;
        border: none;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        &:hover { background: #E5E7EB; }
      }
    }

    .modal-body {
      padding: 8px 24px 20px;

      .modal-title {
        font-size: 20px;
        font-weight: 600;
        color: #1F2937;
        margin: 0 0 8px;

        &.read-title {
          color: #9CA3AF;
        }
      }

      .modal-time {
        font-size: 12px;
        color: #9CA3AF;
        margin-bottom: 16px;
      }

      .modal-divider {
        height: 1px;
        background: #F3F4F6;
        margin: 16px 0;
      }

      .modal-content {
        line-height: 1.6;
        color: #4B5563;
        font-size: 14px;
      }

      .modal-info {
        background: #F9FAFB;
        padding: 12px 16px;
        border-radius: 16px;
        margin-top: 20px;
        display: flex;
        gap: 12px;

        .info-label { font-size: 12px; color: #9CA3AF; }
        .info-value { font-size: 13px; font-weight: 500; color: #1F2937; }
      }
    }

    .modal-footer {
      padding: 16px 24px 24px;
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      border-top: 1px solid #F3F4F6;

      .modal-btn {
        padding: 8px 20px;
        border-radius: 40px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s;
        border: none;

        &.primary {
          background: #1F2937;
          color: white;
          &:hover { background: #374151; }
        }

        &.secondary {
          background: #F3F4F6;
          color: #4B5563;
          &:hover { background: #E5E7EB; }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .workbench-inner { padding: 20px; }
    .hero-stats { padding: 8px 16px; gap: 16px; }
    .hero-stat-value { font-size: 22px !important; }
    .metrics-grid { grid-template-columns: repeat(2, 1fr); gap: 12px; }
    .filter-bar { flex-direction: column; align-items: stretch; }
    .message-item { flex-direction: column; align-items: flex-start !important; gap: 12px; }
    .item-right { align-self: flex-end; }
  }
}
</style>